<div *ngIf="!HideCat" class="email-container px-3">

  <div class="row" >
    <div class="col-md-3 col-lg-3 col-xl-2 bg-white border-right">
      <!-- style="padding-top: 40px;">-->
      <app-categorie-nav 
            [(Categorie)]="sidebarnavItems"
            [(CatFull)]="sidebarnavItems"
            [Sublist]="false"
            [HasAdd]="true"
            (Refresh)="Refresh()"
            (Save)="save($event)"
            (Navigate)="clicked($event)" 
            [(sel_cat_id)]="sel_cat_id"
            [Capacita]="['gestione-documenti']"
            (DeleteClick)="Elimina($event)"
             ></app-categorie-nav>
    </div>
    <div class="p-3 col-md-9 col-lg-9 col-xl-10 bg-white">
      <div class="inbox-right-panel">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</div>
<div *ngIf="HideCat">
  <router-outlet></router-outlet>
</div>








<!--<ng-template #editTicketModal let-modal>-->
<!--  <div class="modal-header">-->
<!--    <h5 class="modal-title" id="editUserLabel">Categoria</h5>-->
<!--    <button type="button" class="close" (click)="closeBtnClick()" aria-label="Close">-->
<!--      <span aria-hidden="true">&times;</span>-->
<!--    </button>-->
<!--  </div>-->

<!--  <div class="modal-body">-->
<!--    <div class="row">-->
<!--      <div class="input-group col-12">-->
<!--        <div class="">-->
<!--          <label class="input-group-text" for="nome">Nome Categoria:</label>-->
<!--        </div>-->
<!--        <input type="text" [(ngModel)]="LabelCategoria" name="nome" class="form-control">-->
<!--      </div>-->
<!--      <div class="col-12">-->
<!--        <label for="categorie" class="control-label col-form-label">Categorie Padre:</label>-->
<!--        <ng-multiselect-dropdown style="width: 80%; " [placeholder]="'Seleziona'" name="categorie"-->
<!--          [data]="CategorieLineare" [(ngModel)]="CategorieSelezionate" [settings]="categoriedropdownSettings"-->
<!--          (onFilterChange)="filtroCategoria($event)">-->
<!--        </ng-multiselect-dropdown>-->
<!--      </div>-->
<!--    </div>-->
<!--    <div class="d-md-flex align-items-center p-3" style="padding-right: 25px;">-->
<!--      <button type="submit" (click)="saveModalButton()"-->
<!--        class="ml-auto btn btn-rounded btn-success p-2 waves-effect waves-light">-->
<!--        <span class="ml-1 text-white font-weight-bold"> Salva </span>-->
<!--        <i-feather name="save" class="feather-md "></i-feather>-->
<!--      </button>-->
<!--    </div>-->
<!--  </div>-->
<!--</ng-template>-->

<ng-template #editTicketModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title" id="editUserLabel">Categoria</h5>
    <button type="button" class="close" (click)="closeBtnClick()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div class="row">

      <div class="input-group col-12" >
        <div class="">
          <label class="input-group-text" >Nome Categoria:</label>
        </div>
        <input type="text" [(ngModel)]="LabelCategoria" name="nome" class="form-control">
      </div>
      <div class="col-12">
        <label  class="control-label col-form-label">Categorie Padre:</label>
        <ng-multiselect-dropdown style="width: 80%; " [placeholder]="'Seleziona'" name="categorie" [data]="CategorieLineare"
                                 [(ngModel)]="CategorieSelezionate" [settings]="categoriedropdownSettings"
                                 (onFilterChange)="filtroCategoria($event)">
        </ng-multiselect-dropdown>
      </div>
      <div class="col-12" *ngIf="permission.HasCapacity(['cat_color'])">
        <div class="">
          <label class="input-group-text" >Colore:</label>
        </div>
        <input type="color" [(ngModel)]="CategoriaDaModificare.colore" name="nome" class="form-control">
      </div>
<!--      <div class="input-group col-12" *ngIf="permission.HasCapacity(['cat_Icon'])">-->
<!--        <div class="">-->
<!--          <label class="input-group-text" >Icona:</label>-->
<!--        </div>-->
<!--        <input type="file" class="upload" (change)="Iconacambiata($event)">-->
<!--      </div>-->
      <div class="input-group col-12" *ngIf="Env.ProdottiAddOn.cat_Sort">
        <div class="">
          <label class="input-group-text">Ordine:</label>
        </div>
        <input type="number" [(ngModel)]="Ordine" name="nome" class="form-control">
      </div>
      <div class="col-12" *ngIf="Env.ProdottiAddOn.cat_image">
        <h5 class="card-title m-t-20">{{'prodotti.UploadImage' | translate}}</h5>
        <div class="el-element-overlay">
          <div class="el-card-item">
            <div class="el-card-avatar el-overlay-1">
              <img [src]="CategoriaDaModificare?.immagine ? CategoriaDaModificare?.immagine : apiPaths.getBaseAPI()+'/file/image/'+CategoriaDaModificare?.id_immagine?.toString()" alt="user" />
              <div class="el-overlay">
                <ul class="list-style-none el-info">
                  <li class="el-item">
                    <a class="btn default btn-outline image-popup-vertical-fit el-link" [href]="CategoriaDaModificare?.immagine ? CategoriaDaModificare?.immagine : apiPaths.getBaseAPI()+'/file/image/'+CategoriaDaModificare?.id_immagine?.toString()">
                      <i class="icon-magnifier"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="btn btn-info waves-effect waves-light">
          <span>Upload Anonther Image</span>
          <input type="file" class="upload" (change)="immaginecambiata($event)"> </div>
      </div>
    </div>
    <div class="d-md-flex align-items-center p-3" style="padding-right: 25px;">
      <button type="submit" (click)="saveModalButton()" class="ml-auto btn btn-rounded btn-success p-2 waves-effect waves-light">
        <span class="ml-1 text-white font-weight-bold"> Salva </span>
        <i-feather name="save" class="feather-md "></i-feather>
      </button>
    </div>
  </div>
</ng-template>

<ng-template #DeleteCategoriaModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title" id="editUserLabel">Elimina Categoria</h5>
    <button type="button" class="close" (click)="closeBtnClick()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div class="row">
      <div class="col-12">
        <label for="categorie" class="control-label col-form-label">Categorie a cui assegnare le categorie
          figlie:</label>
        <ng-multiselect-dropdown style="width: 80%; " [placeholder]="'Seleziona'" name="categorie"
          [data]="CategorieLineare" [(ngModel)]="CategorieSelezionate" [settings]="categoriedropdownSettings"
          (onFilterChange)="filtroCategoria($event)">
        </ng-multiselect-dropdown>
      </div>
    </div>
    <div class="d-md-flex align-items-center p-3" style="padding-right: 25px; margin-top: 25px;">
      <button type="submit" (click)="deleteModalButton()"
        class="ml-auto btn btn-rounded btn-danger p-2 waves-effect waves-light">
        <span class="ml-1 text-white font-weight-bold"> Elimina </span>
        <i-feather name="trash-2" class="feather-md "></i-feather>
      </button>
    </div>
  </div>
</ng-template>
